import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateChallengeAction = createAsyncThunk(
    'update-challenge',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/edit/challenge/${data?.challenge_id}`,{...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateChallengeSlice = createSlice({
    name: 'update-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateChallengeAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateChallengeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateChallengeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateChallengeReducer = updateChallengeSlice.reducer    